import { render, staticRenderFns } from "./shop-card-sales.vue?vue&type=template&id=4c88c095&scoped=true&"
import script from "./shop-card-sales.vue?vue&type=script&lang=js&"
export * from "./shop-card-sales.vue?vue&type=script&lang=js&"
import style0 from "./shop-card-sales.vue?vue&type=style&index=0&id=4c88c095&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88c095",
  null
  
)

export default component.exports